import { render, staticRenderFns } from "./CookiePolicyPage.vue?vue&type=template&id=ab76b32a&scoped=true&"
import script from "./CookiePolicyPage.vue?vue&type=script&lang=js&"
export * from "./CookiePolicyPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab76b32a",
  null
  
)

export default component.exports